import { AxiosResponse } from 'axios';

import axiosInstance from 'config/axios';

/**
 * @description Auth service
 * @type {AuthService}
 */
const AuthService = {
  /**
   * @description Ends the server-side session record for this client before signing out of
   * Cognito (DLA-1469). Without it a clean sign-out leaves a stale session row that is only
   * replaced by the next login, making the next sign-in look like it displaced a session.
   *
   * Only the session for the app client this token belongs to is cleared, so signing out here
   * does not end a session held on another client.
   *
   * `skipAuthRedirect` is essential, not incidental: this call is made while the caller is
   * already signing out and it legitimately 401s whenever the session is gone (expired token,
   * or a displacement that happened first). Letting the interceptor act on that 401 would
   * assign `window.location.href` mid-sign-out — tearing the page down before Amplify's tokens
   * are cleared, so the reload refreshes the session and signs the user straight back in.
   *
   * @SADtrace SAD-003-2.1
   *
   * @History
   * 08-18-2026 aleksandar dukleski: DLA-1469 created
   * 08-18-2026 aleksandar dukleski: DLA-1469 add the missing /v1 prefix and opt out of the
   *   sign-out redirect
   *
   * @returns {Promise<AxiosResponse>} Resolves once the session record is cleared
   */
  logout: async (): Promise<AxiosResponse> => {
    return axiosInstance.post('/v1/auth/logout', null, {
      skipAuthRedirect: true,
    });
  },
};

export default AuthService;
